import { Injectable, Injector } from '@angular/core';
import { EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { AbstractRepositoryV2 } from 'src/app/modules/core/service/v2/abstractRepositoryV2';
import { PaymentCardReaderModel } from '../../../api/entity/paymentCardReader.model';

@Injectable({
    providedIn: 'root'
})
export class PaymentCardReaderRepository extends AbstractRepositoryV2<PaymentCardReaderModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('PaymentCardReader', serviceElementsFactory, injector);
    }
}
